import { render, staticRenderFns } from "./iosBanner.vue?vue&type=template&id=4736e52e&scoped=true&"
import script from "./iosBanner.vue?vue&type=script&lang=js&"
export * from "./iosBanner.vue?vue&type=script&lang=js&"
import style0 from "./iosBanner.vue?vue&type=style&index=0&id=4736e52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736e52e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
